import React from 'react';
import { Block, BLOCKS, Inline } from '@contentful/rich-text-types';

import { ILearningCenterSidebarCalloutFields } from '../../../../../types/contentful';

import { Box } from '../../../Box';
import { Text } from '../../../Text';
import RichText from '../../../RichText';
import CtaWidget from '../../../CtaWidget';

import {
  ctaWidgetEnum,
  DEFAULT_LABEL,
  DEFAULT_PLACEHOLDER
} from '../../../CtaWidget/shared';

import { ParagraphWithLineBreaks } from '../../../RichText/styles';
import { CtaWrapper } from './styles';
import { RenderNode } from '@contentful/rich-text-react-renderer';

const disclaimerOverrideOptions: RenderNode = {
  [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
    return <p className="text-center text-xs">{children}</p>;
  }
};

const secondaryTextOverrideOptions: RenderNode = {
  [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
    return (
      <ParagraphWithLineBreaks
        as="p"
        textAlign={'center'}
        fontSize={{ 0: 'p_0', tablet: 'p_desktop' }}
      >
        {children}
      </ParagraphWithLineBreaks>
    );
  }
};

export function SidebarCallout({
  headerText,
  bodyText,
  ctaWidget,
  secondaryText,
  disclaimer,
  segmentEventProperty = 'newsletter'
}: ILearningCenterSidebarCalloutFields) {
  return (
    <div
      data-testid="sidebar-callout-layout"
      className="!m-0 flex flex-wrap content-center items-center rounded-2xl bg-white p-5 tablet:mt-4"
    >
      <div className="column w-full flex-col !p-0">
        {headerText && (
          <Text
            as="h3"
            fontWeight="h3"
            fontSize={{ 0: 'h3_0', tablet: 'h3_tablet' }}
            textAlign={'center'}
            style={{ letterSpacing: '.5px' }}
          >
            {headerText}
          </Text>
        )}
        <Box marginTop={{ 0: 'm', tablet: 'ml' }}>
          {bodyText && (
            <Text
              as="p"
              textAlign={'center'}
              fontSize={{ 0: 'p_0', tablet: 'p_desktop' }}
            >
              {bodyText}
            </Text>
          )}
        </Box>
        <CtaWrapper
          flexDirection="column"
          justifyContent="center"
          justifySelf="center"
          alignItems="center"
          margin={{
            0: ['m', 'auto', 0, 'auto'],
            tablet: ['ml', 'auto', 0, 'auto']
          }}
          data-e2e="sidebar-cta"
        >
          <CtaWidget
            id="sidebar-cta-phone-number"
            module="Sidebar Callout"
            errorPosition="bottom"
            responsive
            designType={ctaWidgetEnum.MOBILE_PHONE_NUMBER}
            label={DEFAULT_LABEL}
            placeholder={DEFAULT_PLACEHOLDER}
            {...ctaWidget?.fields}
            sysId={ctaWidget?.sys?.contentType?.sys?.id}
            additionalSegmentData={{ segmentEventProperty }}
          />
        </CtaWrapper>
        {disclaimer && (
          <div className="mt-3">
            <RichText
              data={disclaimer}
              overrideOptions={disclaimerOverrideOptions}
            />
          </div>
        )}
        {secondaryText && (
          <Box marginTop={{ 0: 'ml', tablet: 'l' }}>
            <RichText
              data={secondaryText}
              overrideOptions={secondaryTextOverrideOptions}
            />
          </Box>
        )}
      </div>
    </div>
  );
}
